import '~/js/modules/stickyNav';
import '~/js/modules/magnific-popup';
import dataLayerProvider from '~/js/modules/resorts/datalayer-provider';

const { dataLayer = {} } = window.beaches_app.page;

dataLayerProvider.inject(dataLayer);

const playlistID = document.getElementById('playlistID').value;
let counter = 0;
let scrollTop = 0;
const injectTarget = document.getElementById('injectTarget');

document.querySelector('.rm-menu-item:last-of-type a').classList.add('rm-menu-link--active');

if (playlistID !== '') {
  fetch(`https://www.googleapis.com/youtube/v3/playlistItems?part=snippet%2CcontentDetails&maxResults=25&playlistId=${playlistID}&key=AIzaSyB0MfMxQfmyMECCVU6mKY27iSPuckI3oZY`).then((response) => {return response.json();}).then((json) => {
    const videos = json.items;
    const videoArray = [];

    if (playlistID !== '') {
      videos.forEach((video, index, array) => {
        const date = new Date(video.contentDetails.videoPublishedAt);
        const year = date.getUTCFullYear();

        if ((video.snippet.title !== 'Private video') && (+year >= 2015)) {
          const title = video.snippet.title;
          let description = video.snippet.description;

          if (description.includes('videoID')) {
            description = description.split('videoID')[0];
          }
          let thumbnail;

          if (video.snippet.thumbnails.maxres) {
            thumbnail = video.snippet.thumbnails.maxres.url;
          } else if (video.snippet.thumbnails.standard) {
            thumbnail = video.snippet.thumbnails.standard.url;
          } else if (video.snippet.thumbnails.high) {
            thumbnail = video.snippet.thumbnails.high.url;
          } else if (video.snippet.thumbnails.medium) {
            thumbnail = video.snippet.thumbnails.medium.url;
          } else {
            thumbnail = video.snippet.thumbnails.default.url;
          }
          const videoID = video.snippet.resourceId.videoId;

          videoArray.push(`
          <div class='video row'>
          <div class='xs-12 lg-5 xl-4 videoPreview'>
          <a class='js-magnific-video' href='https://www.youtube.com/watch?v=${videoID}'>
          <i class='icon-youtube'></i>
          <img class='lazyload' src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' data-src='${thumbnail}' />
          </a>
          </div>
          <div class='xs-12 lg-7 xl-8 videoDescription'>
          <h4>${title}</h4>
          <p>${description}</p>
          <a class='js-magnific-video' href='https://www.youtube.com/watch?v=${videoID}'>View Video <i class='icon-arrow-right'></i></a>
          </div>
          </div>`);
          counter++;
        } else {
          counter++;
        }
        if (counter === array.length) {
          injectTarget.innerHTML = videoArray.join('');
        }
      });

      $('.js-magnific-video').magnificPopup({
        closeMarkup: '<button class="mfp-close" role="button" tabindex="0"></button>',
        type: 'iframe',
        mainClass: 'video-popup',
        fixedContentPos: true
      });

      if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        $(document).on('Modal.Fixed', (e, data) => {
          if (data) {
            scrollTop = $(window).scrollTop();
            $('body').css('overflow', 'hidden');
            $('body').css('position', 'fixed');
            $('body').css('width', '100%');
            $('body').css('top', scrollTop * (-1) + 'px');
          } else {
            $('body').css('overflow', 'auto');
            $('body').css('top', '0');
            $('body').removeAttr('style');
            $(window).scrollTop(scrollTop);
          }
        });
      }
    }
  });
} else {
  const noVideos = '<div class=\'xs-12\' id=\'noVideo\'><h3>Videos Coming Soon!</h3></div>';

  injectTarget.innerHTML = noVideos;
}
